import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { BLOGS_GET, BLOGS_CANCEL } from 'data/constants';

import { MainViewHandler } from 'shared/hocs';
import Types from 'shared/types/Articles.types';

import PostsList from './components/PostsList/PostsList.view';

export class BlogsList extends Component {
  static propTypes = {
    fetchData: PropTypes.func.isRequired,
    cancelFetch: PropTypes.func.isRequired,
    count: PropTypes.number.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape(Types.articleItemProperties)).isRequired,
  }

  render() {
    return (
      <PostsList
        {...this.props}
      />
    );
  }
}

const mapStateToProps = state => ({
  state: state.blogsList.state,
  count: state.blogsList.count,
  items: state.blogsList.list,
});

const mapDispatchToProps = dispatch => ({
  fetchData: params => dispatch({
    type: BLOGS_GET,
    params,
  }),
  cancelFetch: () => dispatch({
    type: BLOGS_CANCEL,
  }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MainViewHandler(BlogsList));
